module.exports = __webpack_public_path__ + "img/kahler_mobile1.83eb8322.png";